import { render } from "./SectionFaq.vue?vue&type=template&id=2e6c480e&scoped=true"
import script from "./SectionFaq.vue?vue&type=script&lang=js"
export * from "./SectionFaq.vue?vue&type=script&lang=js"

import "./SectionFaq.vue?vue&type=style&index=0&id=2e6c480e&lang=scss&scoped=true"

import exportComponent from "/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e6c480e"]])

export default __exports__